<script>
import VClamp from 'vue-clamp';

export default {
  name: 'CpMemberComponent',
  directives: {
    margin: require('../directives/margins').margin,
  },
  components: {
    handleImageError: require('../mixins/utils').default,
    VClamp,
  },
  props: {
    image: { type: String, default: '' },
    fullname: { type: String, default: '' },
    description: { type: String, default: '' },
    permalink: { type: String, default: '' },
    maxLines: { type: Number, default: 2 },
  },
  data() {
    return {};
  },
  methods: {
    navigateTo(path) {
      window.location.href = path;
    },
  },
};
</script>
<template>
  <span @click.prevent="permalink && navigateTo(permalink)" :disabled="permalink" class="memberContainer">
    <div class="memberImage">
      <div class="circle-container">
        <img :src="`${image}`" alt="Member's image" @error="handleImageError" />
      </div>
    </div>
    <span class="textContainer">
      <p class="caption1 neutral6-color" v-margin="0">{{ fullname }}</p>
      <p class="caption2 neutral6-color" v-margin="0">
        <VClamp autoresize :max-lines="maxLines">{{ description }}</VClamp>
      </p>
    </span>
  </span>
</template>

<style scoped>
.memberContainer {
  display: flex;
  align-items: center;
  padding: 8px;
  margin: 4px 0;
  cursor: pointer;
}
.memberImage {
  background: var(--primary1);
  margin-right: 10px;
  border-radius: 50%;
}
.circle-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.textContainer {
  display: flex;
  flex-direction: column;
}
</style>
